import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
// @ts-ignore This import fails when compiling to CJS.
import { Listbox } from '@headlessui/react';
import * as scaleChromatic from 'd3-scale-chromatic';
import { Fragment } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import FixedGradientPreview from '../preview/FixedGradientPreview';
export const fixedGradientScales = {
    turbo: scaleChromatic.interpolateTurbo,
    viridis: scaleChromatic.interpolateViridis,
    inferno: scaleChromatic.interpolateInferno,
    magma: scaleChromatic.interpolateMagma,
    plasma: scaleChromatic.interpolatePlasma,
};
const scaleOptions = Object.keys(fixedGradientScales);
const GradientSelectListbox = styled.div `
  position: relative;
  width: 100%;
  border: 1px solid darkgray;
  border-radius: 0.25rem;
`;
const GradientSelectButton = styled.button `
  position: relative;
  width: 100%;
  height: 30px;
  padding: 3px;
`;
const GradientSelectChevron = styled(FaChevronDown) `
  position: absolute;
  height: 100%;
  top: 0;
  right: 0.5rem;
`;
const GradientSelectOptions = styled.ul `
  position: absolute;
  width: 100%;
  margin-top: 5px;
  border: 1px solid darkgray;
  border-radius: 0.25rem;
  padding-inline: 3px;
  padding-bottom: 5px;
`;
const GradientSelectOption = styled.li `
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  cursor: pointer;
  ${(props) => !props.active && 'opacity: 0.8;'}
  ${(props) => props.active && 'font-weight: bold;'}
`;
export function GradientSelect(props) {
    const { value, onChange } = props;
    return (_jsx(Listbox, { value: value, onChange: onChange, children: _jsxs(GradientSelectListbox, { children: [_jsxs(Listbox.Button, { as: GradientSelectButton, children: [_jsx(FixedGradientPreview, { gradient: value }), _jsx(GradientSelectChevron, {})] }), _jsx(Listbox.Options, { as: GradientSelectOptions, children: scaleOptions.map((option) => (_jsx(Listbox.Option, { as: Fragment, value: option, children: ({ active }) => (_jsxs(GradientSelectOption, { active: active, children: [option, _jsx("div", { style: { height: 15 }, children: _jsx(FixedGradientPreview, { gradient: option }) })] })) }, option))) })] }) }));
}
//# sourceMappingURL=GradientSelect.js.map